import React from "react";
import { makeStyles } from "@mui/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import RootFooter from "../../../components/RootFooter";
import { RootTopBar } from "../../../components";
import adminImage from "../../../assets/Images/admin.png"

const customStyles = makeStyles({
  root: {
    padding: "100px 0px",
    width: "90%",
    maxWidth: "1216px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginRight: "auto",
    marginLeft: "auto",
    fontFamily: "Montserrat",
  },
  leftContent: {
    maxWidth: "50%",
  },
  headerBtnWrapper: {
    display: "flex",
    marginTop: "50px",
    gap: "16px",
  },
  header: {
    margin: "26px 0px",
    color: "black",
    fontSize: "64px",
    fontWeight: 600,
    lineHeight: 1.1,
    fontFamily: "Montserrat",
  },
  imageWrapper: {
    maxWidth: "45%",
  },
  image: {
    width: "100%",
    height: "auto",
    borderRadius: "8px",
  },

  // ---------- MEDIA QUERIES ----------

  '@media (max-width: 319px)': {
    root: {
      flexDirection: "column",
      padding: "50px 10px",
    },
    leftContent: {
      maxWidth: "100%",
    },
    header: {
      fontSize: "28px",
    },
    imageWrapper: {
      maxWidth: "100%",
      marginTop: "30px",
    },
  },

  '@media (min-width: 320px) and (max-width: 480px)': {
    root: {
      flexDirection: "column",
      padding: "60px 15px",
    },
    leftContent: {
      maxWidth: "100%",
    },
    header: {
      fontSize: "32px",
    },
    imageWrapper: {
      maxWidth: "100%",
      marginTop: "30px",
    },
  },

  '@media (min-width: 481px) and (max-width: 768px)': {
    root: {
      flexDirection: "column",
      padding: "70px 20px",
    },
    leftContent: {
      maxWidth: "100%",
    },
    header: {
      fontSize: "40px",
    },
    imageWrapper: {
      maxWidth: "100%",
      marginTop: "30px",
    },
  },

  '@media (min-width: 769px) and (max-width: 1024px)': {
    root: {
      flexDirection: "column",
      padding: "80px 40px",
    },
    leftContent: {
      maxWidth: "100%",
    },
    header: {
      fontSize: "48px",
    },
    imageWrapper: {
      maxWidth: "90%",
      marginTop: "30px",
    },
  },

  '@media (min-width: 1025px) and (max-width: 1440px)': {
    root: {
      flexDirection: "row",
      padding: "90px 60px",
    },
    leftContent: {
      maxWidth: "50%",
    },
    header: {
      fontSize: "56px",
    },
    imageWrapper: {
      maxWidth: "45%",
    },
  },

  '@media (min-width: 1441px)': {
    // Desktop default (no changes needed, just restate if desired)
    root: {
      flexDirection: "row",
    },
    leftContent: {
      maxWidth: "50%",
    },
    header: {
      fontSize: "64px",
    },
    imageWrapper: {
      maxWidth: "45%",
    },
  },
});

const Admin = () => {
  const classes = customStyles();
  const navigate = useNavigate();

  return (
    <>
      <RootTopBar />
      <div className={classes.root}>
        {/* Left Content */}
        <div className={classes.leftContent}>
          <span className="font-size-18 purple-text">
            <span className="grey-text" style={{ fontFamily: "Montserrat" }}>
              Home &gt;{" "}
            </span>
            <span style={{ fontFamily: "Montserrat" ,color:"black"}}>Admin Onboard</span>
          </span>
          <h1 className={classes.header}>Admin Onboard</h1>

          <div className={classes.headerBtnWrapper}>
            <div
              style={{ fontFamily: "Montserrat" ,backgroundColor:"black"}}
              className="purpleBtn"
              onClick={() => {
                navigate(routes.ADMIN_LOGIN);
              }}
            >
              Login <ArrowForwardIcon />
            </div>
          </div>
        </div>

        <div className={classes.imageWrapper}>
          <img
            src={adminImage}
            alt="Admin Illustration"
            className={classes.image}
          />
        </div>
        
      </div>
      <RootFooter />
    </>
  );
};

export default Admin;
